import React, { useState, useRef, useEffect } from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import { observable } from 'legacy-packages/ft-cb';
import SubmitSuccessContent from '../SubmitSuccessContent';

const PracticeConfirmationPopover = ({
  app,
  onClose,
  onPracticeFlowToggle,
  goToQuestion,
  learnositySubmit,
  onExitPlayer,
  isImpersonating,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const reviewContentRef = useRef(null);
  const [isExitButtonDisabled, setIsExitButtonDisabled] = useState(false);

  useEffect(() => {
    const submissionReadyCallback = (submissionReady) => {
      setIsExitButtonDisabled(!submissionReady);
    };

    observable.subscribe('submissionReady', submissionReadyCallback);

    return () => {
      observable.unsubscribe('submissionReady', submissionReadyCallback);
    };
  }, []);

  const submitAndClose = () => {
    setIsSubmitted(true);
    learnositySubmit();
  };

  const close = () => {
    onClose();
  };

  const startReview = () => {
    // go to first item and start review
    onClose();
    goToQuestion(Object.keys(app.getItems())[0]);
    onPracticeFlowToggle(true);
  };

  useEffect(() => {
    reviewContentRef.current && reviewContentRef.current.focus();
  }, []);

  const title = isSubmitted
    ? 'Assignment submitted'
    : 'See how this question is scored on an AP Exam';

  let modalContent;
  let isPrimaryBtnDisabled;
  if (isSubmitted) {
    isPrimaryBtnDisabled = isExitButtonDisabled && !isImpersonating;
    modalContent = {
      btnPrimary: 'Exit',
      btnPrimaryAria: {
        'data-test-button-exit': true,
      },
    };
  } else {
    modalContent = {
      btnPrimary: 'Yes, Review',
      btnSecondary: 'No, Submit Now',
    };
  }

  return (
    <ConfirmDialog
      size="tiny"
      title={title}
      onSuccess={isSubmitted ? onExitPlayer : startReview}
      onClose={isSubmitted ? onExitPlayer : close}
      onSecondaryBtnClick={submitAndClose}
      content={modalContent}
      isPrimaryBtnDisabled={isPrimaryBtnDisabled}
    >
      {isSubmitted ? (
        <SubmitSuccessContent isSoftTime />
      ) : (
        <p ref={reviewContentRef}>
          Before you submit, would you like to review how this question might be
          scored
          <br />
          on an AP Exam? You can review and optionally revise your response.
        </p>
      )}
    </ConfirmDialog>
  );
};

export default PracticeConfirmationPopover;
